import { render, staticRenderFns } from "./Util-Item-Kue.vue?vue&type=template&id=724d29dc"
import script from "./Util-Item-Kue.vue?vue&type=script&lang=js"
export * from "./Util-Item-Kue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports